const utils = {
  setCookie (cname, cvalue = null, opts = {}) {
    const { exDay = 1, domain = '', path = '/' } = opts

    let expires = ''

    if (exDay) {
      const date = new Date()
      date.setTime(date.getTime() + (exDay * 24 * 60 * 60 * 1000))
      expires = ';expires=' + date.toGMTString()
    }

    const pathHandle = ';path=' + path
    const domainHandle = domain ? ';domain=' + domain : ''
    cvalue = typeof cvalue === 'object' ? JSON.stringify(cvalue) : cvalue
    document.cookie = cname + '=' + encodeURIComponent(cvalue) + expires + pathHandle + domainHandle
  },

  getCookie (cname) {
    const name = cname + '='
    const cArr = document.cookie.split(';')
    let cookie = ''
    cArr && cArr.map(item => item.trim().indexOf(name) === 0 && (cookie = item))
    return cookie && encodeURIComponent(cookie.split(name)[1])
  },

  _uaList: (() => {
    const ua = navigator.userAgent.toLowerCase()
    return {
      ie: ua.includes('trident'), // IE内核
      mobile: !!ua.match(/applewebkit.*mobile.*/), // 是否为移动终端
      ios: !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/), // ios终端
      android: ua.includes('android') || ua.includes('linux'), // android终端
      iphone: ua.includes('iphone'), // 是否为iPhone
      ipad: ua.includes('ipad'), // 是否iPad
      wx: ua.includes('micromessenger'), // 是否微信
      pc: !ua.match(/applewebkit.*mobile.*/) && !ua.includes('ipad'), // 是否iPad
    }
  })(),
  UAis (device) {
    return this._uaList[device]
  },

  verifyPhone (phone) {
    const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|1(8|9)[0-9]|14[57])[0-9]{8}$/
    return reg.test(phone)
  },

  EUIRule (type, name, opts = {}) {
    const { trigger = 'blur', minlength, max, min } = opts

    switch (type) {
      case 'required':
        if (max || min) {
          return [
            { required: true, message: `${name}不能为空`, trigger },
            opts
          ]
        } else {
          return { required: true, message: `${name}不能为空`, trigger }
        }
        break;

      case 'price':
        return {
          validator: (rule, val, cb) => {
            if (val && !utils.verifyPhone(val)) {
              cb(new Error('请输入正确的手机号'))
            } else {
              cb()
            }
          },
          trigger
        }
        break

      default:
        break;
    }
  }
}

export default utils